import { Component, computed, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AlerteComponent } from '@shared/components/alerte/alerte.component';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';

import { DomSanitizer } from '@angular/platform-browser';
import { TrierParPipe } from '@shared/pipes/trier-par.pipe';
import { HlmSeparatorImports } from '@spartan-ng/helm/separator';
import { MessageInformationStore } from '../administration/messages-information/store/message-information.store';
import { UserStore } from '../auth/store/user.store';
import { AdministrationComponent } from './administration/administration.component';
import { OffreDeFormationComponent } from './offre-de-formation/offre-de-formation.component';
import { VisualisationReferentielComponent } from './visualisation-referentiel/visualisation-referentiel.component';

@Component({
  selector: 'app-dashboard',
  imports: [
    OffreDeFormationComponent,
    HlmCardImports,
    HlmButtonImports,
    RouterModule,
    AdministrationComponent,
    VisualisationReferentielComponent,
    AlerteComponent,
    HlmSeparatorImports,
    TrierParPipe,
  ],
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent implements OnInit {
  readonly #userStore = inject(UserStore);
  readonly #messageStore = inject(MessageInformationStore);
  readonly #sanitizer = inject(DomSanitizer);

  readonly isAdmin = computed(() => this.#userStore.isAdmin());
  readonly hasNoRole = computed(() => this.#userStore.hasNoRole());
  readonly messages = computed(() =>
    this.#messageStore.entities().map((x) => ({ ...x, contenu: this.#sanitizer.bypassSecurityTrustHtml(x.contenu) })),
  );

  ngOnInit(): void {
    this.#messageStore.charger(true);
  }
}
